
import { defineStore } from 'pinia';

import { host, authClient } from "../api/config.js";

import { useVisitorAppointmentsStore } from './visitor-appointments-store';


export const useAuthStore = defineStore('authStore', {

    state: () => {
        return {
            currentUser: null,
            token: '',
            profile: null
        }
    },
    actions: {
        signIn(data) {
            return new Promise((resolve, reject) => {
                authClient.signIn(data).then(res => {
                    console.log(res);
                    if (!res.networkError) {
                        if (res.status == 200) {
                            this.token = res.body.auth.authToken;
                            delete res.body.auth.authToken;
                            this.currentUser = res.body.auth;
                            this.profile = res.body.profile;
                            if (this.profile && this.profile.imageUrl && this.profile.imageUrl.length > 0)
                                this.profile.imageUrl = host + this.profile.imageUrl;
                            localStorage.setItem('token', this.token);
                            localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
                            localStorage.setItem('profile', JSON.stringify(this.profile));
                            resolve();
                        } else {
                            reject('auth_error');
                        }
                    } else {
                        reject('network_error');
                    }
                });
            }); 
        },
        signOut() {
            return new Promise((resolve, reject) => {
                authClient.signOut().then(res => {
                    this.currentUser = null;
                    this.token = '';
                    this.profile = null;
                    useVisitorAppointmentsStore().clear();
                    localStorage.removeItem('token');
                    localStorage.removeItem('currentUser');
                    localStorage.removeItem('profile');
                    resolve();
                });
            });
        },
        init() {
            this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
            this.profile = JSON.parse(localStorage.getItem('profile'));
        }
    },

    
});
